export const FOREX_MODULE_NAME: string = 'forex';

export enum ForexGetter {
	menu = 'menu',
	sidebar = 'sidebar',
	courseBuy = 'courseBuy',
	courseSell = 'courseSell',
}

export enum ForexMutation {
	setCount = 'setCount',
	setCourse = 'setCourse',
	resetCourse = 'resetCourse',
}

export enum ForexAction {
	loadCourse = 'loadCourse',
	loadCount = 'loadCount',
}